import React from 'react';
import { isWidgetEnabled, WidgetContext } from '../../../data/widgets/WidgetContext';
import { getMatchIdOrStageId } from '../../utils';
import { getEnv } from '../../env';

export default function LiveTrackerToggle(props) {
    const widgetContext = React.useContext(WidgetContext);
    
    const event = props.event;
    const widgetEnabled = isWidgetEnabled(event.sportRef, event.widgetType, event.geniusId, event.lsportWidgetId);

    function toggleLiveTracker(e) {
        e.preventDefault();
        e.stopPropagation();
        const containerId = `#br_widget_checkbet_${event.ticketRef}_${event.id}`;
        if (widgetContext.widgetContainerId !== containerId) {
            if (widgetEnabled) {
                widgetContext.setWidget({
                    widgetGeniusId: event.geniusId,
                    widgetLsportId: event.lsportWidgetId,
                    widgetProviderType: event.widgetType,
                    widgetSportId: event.sportRef,
                    widgetStartCollapsed: true,
                    widgetS5Layout: '#2',
                    widgetMatchId: getMatchIdOrStageId(event),
                    widgetContainerId: containerId
                });
            }
        } else if (event.id !== widgetContext.widgetMatchId) {
            widgetContext.setWidget({
                widgetMatchId: getMatchIdOrStageId(event)
            });
        } else {
            widgetContext.setWidget({
                widgetMatchId: null,
                widgetContainerId: null
            });
        }
    }

    return (
        <>
            {(event.id != null && isWidgetEnabled(event.sportRef,event.widgetType,event.geniusId,event.lsportWidgetId)) &&
                <img src={`${getEnv('PUBLIC_URL')}/assets/images/widget-campetto.png`} alt="" height="20px" width="28px" onClick={toggleLiveTracker} />
            }
        </>
    );
}
